<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close transfer>
			<template #default>
				<div ref="logistictrace_custom_form" style="box-sizing: border-box;padding: 10px;"></div>
<!-- 				<vxe-grid ref="list" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid> -->
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				// {
				// 	"type": "el-divider",
				// 	"children": [
				// 		"日期"
				// 	]
				// },
				{
					"type": "$datePicker",
					"field": "date",
					"title": "日期",
					"props": {
						"type": "month",
						"disabled": false
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},				
				// {
				// 	"type": "el-divider",
				// 	"children": [
				// 		"关联店铺"
				// 	]
				// },
				// {
				// 	"type": "$select",
				// 	"field": "shop",
				// 	"title": "",
				// 	"value": [],
				// 	"hidden": false,
				// 	"options": [{
				// 		"label": "123",
				// 		"value": 1
				// 	}, {
				// 		"label": "123",
				// 		"value": 2
				// 	}, {
				// 		"label": "123",
				// 		"value": 3
				// 	}, {
				// 		"label": "123",
				// 		"value": 4
				// 	}],
				// 	"props": {
				// 		"checkbox": true
				// 	},
				// 	"validate": [{
				// 		"required": true,
				// 		"message": "必填项"
				// 	}]
				// },
				// {
				// 	"type": "el-divider",
				// 	"children": [
				// 		"平台费用"
				// 	]
				// },
				// {
				// 	"type": "$select",
				// 	"field": "cost",
				// 	"title": "",
				// 	"value": ["广告费用", "平台佣金", "营销费用", "其他费用"],
				// 	"hidden": false,
				// 	"options": [{
				// 		"label": "广告费用",
				// 		"value": "广告费用"
				// 	}, {
				// 		"label": "平台佣金",
				// 		"value": "平台佣金"
				// 	}, {
				// 		"label": "营销费用",
				// 		"value": "营销费用"
				// 	}, {
				// 		"label": "其他费用",
				// 		"value": "其他费用"
				// 	}],
				// 	"props": {
				// 		"checkbox": true
				// 	},
				// 	"validate": [{
				// 		"required": true,
				// 		"message": "必填项"
				// 	}]
				// },
				// {
				// 	"type": "el-divider",
				// 	"children": [
				// 		"委托服务费用"
				// 	]
				// },
				// {
				// 	"type": "$input",
				// 	"field": "input",
				// 	"title": "input",
				// 	"value": null,
				// 	"hidden": false,
				// 	"props": {
				// 		"readonly": true
				// 	},
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// },
				// {
				// 	"type": "$upload",
				// 	"field": "upload",
				// 	"title": "upload",
				// 	"value": null,
				// 	"hidden": false,
				// 	"props": {},
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// }
			],
			"option": {
				"form": {
					"labelWidth": "60px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	// import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '涉税信息',
				modal_width: 500,
				modal_height: 200,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 400
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
							type: 'checkbox',
							title: '#',
							width: 50,
						}, {
							field: 'cooperationid',
							title: '合作公司',
							editRender: {
								name: '$company',
								props: {

								},
								events: {

								}
							},
						}, 
						{
							field: 'serviceid',
							title: '委托服务',
							editRender: {
								name: '$emun',
								props: {
									name: "entrustservice"
								},
								events: {
						
								}
							},
						},
						{
							field: 'tax',
							title: '税点(%)',
							editRender: {
								name: '$inputNumber',
								props: {
									
								},
								events: {

								}
							},
						},
						{
							title: '操作',
							fixed: "right",
							align: 'center',
							width: 65,
							slots: {
								default: ({
									row
								}) => {
									return [ <el-button style = "color:#F56C6C;"
										type = "text"
										size = "mini"
										onClick = {
											() => {
												this.delete(row)
											}
										} > 删除 </el-button>]
									}
								}
							}
						]
						gridOptions.formConfig = false
						gridOptions.editRules = {
							c: [{
									required: true
								},
								// {
								// 	validator({cellValue,row}){
								// 		return new Promise((resolve,reject)=>{
								// 			if( true ){
								// 				reject(new Error('自定义错误'))
								// 			}else{
								// 				resolve()
								// 			}

								// 		})
								// 	}
								// },
							]
						}
					},
					list() {
						return new Promise((resolve) => {
							resolve({
								list: []
							})
						})
					},
					modal_init() {
						let formData = JSON.parse(JSON.stringify(formjson))
						let rule = formData.rule.rule
						let option = formData.rule.option
						option.el = this.$refs.logistictrace_custom_form
						this.fApi = this.$formCreate(rule, option)
						this.fApi.nextTick(() => {
							this.regestevent(rule)
							this.setFormData()
						})
						this.$emit('show')
					},
					regestevent(rule) {
						rule.forEach((item) => {
							if (item.field) {
								let on = {}
								if (typeof this[item.field + 'Input'] === 'function') {
									on.input = this[item.field + 'Input']
								}
								if (typeof this[item.field + 'Change'] === 'function') {
									on.input = this[item.field + 'Change']
								}
								if (typeof this[item.field + 'Button'] === 'function') {
									on.inputButtonclick = this[item.field + 'Button']
								}
								this.fApi.updateRule(item.field, {
									on: on
								})
							}
						})
					},
					setFormData() {
						if (this.sourceData) {
							let fields = this.fApi.fields()
							fields.forEach((item) => {
								this.fApi.setValue(item, this.sourceData[item])
							})
						}
					},
					getgrid() {
						return this.$refs.list
					},
					add() {
						this.getgrid().insert({})
					},
					delete(row) {
						this.getgrid().remove(row)
					},
					submit() {
						this.fApi.submit((formData) => {
							let submitData = JSON.parse(JSON.stringify(formData))
							this.submitDataFormater(submitData)
							// this.$api.logistictrace.updatefromlist(this.row.traceID,submitData).then(()=>{
							// 	this.$emit('success')
							// 	this.modal_cancel()
							// })
							console.log(submitData)
							// this.getgrid().validate(true, (res) => {
							// 	if (!res) {
							// 		let submitData = JSON.parse(JSON.stringify(formData))
							// 		this.submitDataFormater(submitData)
							// 		let detail = this.getgrid().getTableData().visibleData
							// 		let data = {}
							// 		data.main = submitData
							// 		data.costorder_detail = detail
							// 		this.createJson(data)
							// 		//console.log(data,123123)
							// 		this.$emit('success', {
							// 			data: JSON.stringify(data)
							// 		})
							// 		this.modal_cancel()
							// 		console.log(data)
							// 	} else {
							// for (let i in res) {
							// 	console.log(res[i][0].rule)
							// 	let content = res[i][0].rule.$options.content
							// 	let message = res[i][0].rule.$options.message
							// 	if(content){
							// 		this.$message.error(content)
							// 	}else if(message){
							// 		this.$message.error(message)
							// 	}else{
							// 		this.$message.error('缺少必填项：' + res[i][0].column.title)
							// 	}

							// }
							// 	}
							// })
						})
						//this.init()
					},
					submitDataFormater(formData) {
						for (let i in formData) {
							if (i.match(/^\$son/)) {
								for (let j in formData[i]) {
									formData[i][j].forEach((item) => {
										for (let k in item) {
											if (k.match(/.*time$/g)) {
												item[k] = item[k] / 1000
											}
										}
									})
								}
							} else if (i.match(/.*time$/g)) {
								console.log(i)
								formData[i] = formData[i] / 1000
							}
						}
					},
					reset() {
						//this.init()
					}
			},
			components: {

			}
		}
</script>